import React, { useEffect, useMemo } from "react";
import { CalendarDays } from "lucide-react";

const PUBLIC_TICKETING_ORIGIN = "https://uniqueingressos.com.br";

function resolveTicketingOrigin(): string {
  const configuredOrigin = String(import.meta.env.VITE_REDIRECT_URL || "")
    .trim()
    .replace(/\/+$/, "");

  if (configuredOrigin !== "" && configuredOrigin !== window.location.origin) {
    return configuredOrigin;
  }

  return PUBLIC_TICKETING_ORIGIN;
}

/**
 * Sends public event deep links to the ticketing application. The ticketing
 * backend decides whether the event is active or must show the ended page.
 */
export function EventRouteRedirect() {
  const targetUrl = useMemo(() => {
    const target = new URL(window.location.pathname, resolveTicketingOrigin());
    target.search = window.location.search;
    target.hash = window.location.hash;

    return target.toString();
  }, []);

  useEffect(() => {
    window.location.replace(targetUrl);
  }, [targetUrl]);

  return (
    <main className="min-h-[65vh] px-5 py-32" aria-live="polite">
      <div className="mx-auto flex max-w-md flex-col items-center text-center">
        <div className="mb-5 grid h-16 w-16 place-items-center rounded-2xl border border-orange-200 bg-orange-50 text-orange-600">
          <CalendarDays className="h-8 w-8" aria-hidden="true" />
        </div>
        <h1 className="mb-3 text-2xl font-semibold">Abrindo o evento</h1>
        <p className="text-muted-foreground">
          Estamos verificando a disponibilidade e preparando a página para você.
        </p>
        <a className="mt-6 font-semibold text-orange-600 underline" href={targetUrl} target="_blank" rel="noopener">
          Continuar para o evento
        </a>
      </div>
    </main>
  );
}
